import React, { useState } from 'react';
import styled from 'styled-components';
import { has } from 'lodash';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
// import { get, isEmpty } from 'lodash';


export const FormPhoneInputField = ({
  field, form: {
    setFieldValue,
    touched,
    errors
    // values
  }, otherProps, ...props
}) => {
  const {
    label,
    placeholder
  } = otherProps;
  const [isOnFocus, setIsOnFocus] = useState(false);

  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const hasError = has(touched, field.name) && has(errors, field.name);

  const handleOnChange = (value, country) => {
    const validNumberCount = (country.format.match(/\./g) || []).length;
    setPhoneNumberError(value.length !== validNumberCount);
    setFieldValue(field.name, value);
    setFieldValue('phoneErr', phoneNumberError);
  };

  return (
    <Block>
      <StyledLabel>{label}</StyledLabel>
      <InputWrapper
        defaultCountry='ca'
        country='ca'
        preferredCountries={['ca', 'cn']}
        value={field.value}
        placeholder={placeholder}
        onChange={handleOnChange}
        onFocus={() => setIsOnFocus(true)}
        isOnFocus={isOnFocus}
        priority={{ ca: 0, us: 1 }}
        {...props}
      />
      {
        hasError && (
          <ErrorText>{errors[field.name]}</ErrorText>
        )
      }
      {
        (!hasError && phoneNumberError) && (
          <ErrorText>Phone number is not valid</ErrorText>
        )
      }
    </Block>
  );
};

  // width: 480px;
const Block = styled.div`
    display: inline-flex;
    flex-direction: column;
    text-align:left;
    width: 100%;
    margin: 0.4em 0;
`;

const StyledLabel = styled.label`
&&&& {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #384455 !important;
}
`;

const InputWrapper = styled(PhoneInput)`
&&& {
    width: 100%;
    background: #FFFFFF;
    border: ${(props) => (props.isOnFocus ? '1px solid #0094fb' : '1px solid #99B2C6')};
    border-radius: 8px;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
}

&& {
    .form-control {
        width: 100%;
        height: 44px;
        border-radius: 8px !important;
        border: none !important;
        outline: none !important;
        padding-left: 3rem !important;
    }

    .flag-dropdown {
        border: none;
        height: 44px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    .selected-flag {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }
}
`;

const HintText = styled.small`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #667085;
`;

const ErrorText = styled(HintText)`
  color: #F04438;
`;



// WEBPACK FOOTER //
// ./src/uiStandard/event/formPhoneInput.js